export const ADD_EXAM_RESULT_REQUEST = 'ADD_EXAM_RESULT_REQUEST'
export const ADD_EXAM_RESULT_SUCCESS = 'ADD_EXAM_RESULT_SUCCESS'
export const ADD_EXAM_RESULT_FALIURE = 'ADD_EXAM_RESULT_FALIURE'
